/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [media-gallery.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 27.05.18 14:16
 */

import React, {useState} from 'react';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

// example for a caption: ['Hey wo ist das Bild gemacht worden? Cool.', <p><Send/> <br/>nanan</p>,'abc', 'Hello again']
const LightboxGallery = ({media, index = 0, open = false, title, caption, onClose = null}) => {
    const [currentIndex, setCurrentIndex] = useState(index);
    const [isOpen, setIsOpen] = useState(open);

    const handleOnClose = () => {
        setIsOpen(false);
        onClose && onClose();
    }

    const handleOnPrev = () => {
        const previous = (currentIndex + media.length - 1) % media.length;
        setCurrentIndex(previous)
    }

    const handleOnNext = () => {
        const next = (currentIndex + 1) % media.length;
        setCurrentIndex(next);
    }

    const getOtherProps = otherProps => {
        if(title) {
            otherProps = {...otherProps, imageTitle: title}
        }
        if(caption) {
            otherProps = {...otherProps, imageCaption: caption}
        }
        return otherProps;
    }

    if (!isOpen) return null;

    return <Lightbox
        {...getOtherProps({})}
        mainSrc={media[currentIndex]}
        nextSrc={media.length > 1 ? media[(currentIndex + 1) % media.length] : null}
        prevSrc={media.length > 1 ? media[(currentIndex + media.length - 1) % media.length] : null}
        onCloseRequest={handleOnClose}
        onMovePrevRequest={handleOnPrev}
        onMoveNextRequest={handleOnNext}/>
}

export default LightboxGallery;